<template>
  <v-dialog
    width="150vh"
    v-model="dialog"
    ref="dialog"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-form ref="form">
      <v-card elevation="0" class="dialog">
        <v-card-title>
          <v-toolbar elevation="0" style="background-color: transparent">
            <v-row align="center" justify="center" dense
              ><span class="text-h4 primary--text"
                >Adicione seu cartão de crédito</span
              >
            </v-row>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="6" class="d-flex align-center justify-center">
              <Card
                :isReadonly="false"
                :checkout="true"
                :data="localItem"
                ref="card"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="d-flex align-center justify-center flex-column"
            >
              <custom-masked-input
                v-model="localItem.maskedNumber"
                label="Número do cartão"
                placeholder="1234 5678 8765 4321"
                :currentValue="localItem.maskedNumber"
                :mask="'#### #### #### ####'"
              />
              <custom-input
                label="Nome no cartão"
                placeholder="Jhon Doe"
                v-model="localItem.holder"
                :currentValue="localItem.holder"
              />
              <custom-masked-input
                label="CPF do titular"
                v-model="localItem.holderDoc"
                :currentValue="localItem.holderDoc"
                :mask="'###.###.###-##'"
                :customRule="rules.document"
              />
              <v-row dense align="center" justify="center">
                <v-col cols="12" md="4">
                  <v-select
                    label="Mês"
                    :items="months"
                    v-model="localItem.expMonth"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    label="Ano"
                    v-model="localItem.expYear"
                    :items="years"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" md="4"
                  ><custom-masked-input
                    type="password"
                    label="CVV"
                    :mask="'###'"
                    v-model="localItem.cvv"
                  ></custom-masked-input
                ></v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            rounded
            outlined
            color="primary"
            class="mr-3"
            @click="dialog = !dialog"
          >
            <v-img contain src="@/assets/icons/undo.svg" class="mr-3"></v-img>
            <span style="text-transform: none">Voltar</span>
          </v-btn>
          <v-btn large rounded color="primary" @click="proceed">
            <v-img contain :src="icon" class="mr-3"></v-img>
            <span class="white--text" style="text-transform: none">Salvar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import Card from "./Card";
import { cpf } from "cpf-cnpj-validator";
export default {
  name: "CheckoutDialog",
  components: {
    Card,
  },
  mixins: [],
  props: {},
  data() {
    return {
      dialog: false,
      fliped: false,
      localItem: {
        holder: "",
        maskedNumber: "",
        exp: "",
        cvv: "",
        expMonth: "",
        expYear: "",
        holderDoc: "",
      },
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      years: [],
      rules: {
        document: [
          (v) => this.validateDocNumber(v) || "Número de documento inválido.",
        ],
      },
    };
  },
  computed: {
    icon() {
      return this.step === 1
        ? require("@/assets/icons/arrow_outline.svg")
        : require("@/assets/icons/refresh.svg");
    },
  },
  watch: {
    "localItem.expMonth": {
      handler: function (value) {
        if (value && !this.fliped) {
          this.$refs.card.flipCard();
          this.fliped = true;
        }
      },
      deep: true,
    },
    "localItem.expYear": {
      handler: function (value) {
        if (value && !this.fliped) {
          this.$refs.card.flipCard();
          this.fliped = true;
        }
      },
      deep: true,
    },
  },
  mounted() {
    for (let year = 0; year <= 10; year++) {
      this.years.push(new Date().getFullYear() + year);
    }
  },
  methods: {
    proceed() {
      if (this.step === 1 && this.$refs.form.validate()) this.step++;
    },
    open() {
      this.dialog = true;
    },
    validateDocNumber(doc) {
      return cpf.isValid(doc);
    },
  },
};
</script>
<style scoped>
.dialog {
  background: rgba(255, 255, 255, 0.4);
  box-shadow: 0 8px 32px 0 rgba(70, 81, 228, 0.37);
  backdrop-filter: blur(7.5px);
  -webkit-backdrop-filter: blur(7.5px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
}
</style>
